<template>
  <div>
    <PictureHeader :img_header="header_image" header="ตั้งค่ารูปภาพเว็บไซต์" link_back="managewebsite"/>
    <MenuPicture/>
    <Cover_setting/>
  </div>
</template>

<script>
import PictureHeader from "@/components/admin/manage_website/picture_setting/menu_picture/PictureHeader";
import HeaderImage from "@/assets/picture_1.png";
import MenuPicture from "@/components/admin/manage_website/picture_setting/menu_picture/MenuPicture";
import Cover_setting from "@/components/admin/manage_website/picture_setting/Cover_setting";
export default {
  name: "CoverSetting",
  components: {
    Cover_setting,
    MenuPicture,
    PictureHeader
  },
  data() {
    return {
      header_image: HeaderImage
    }
  }
}
</script>

<style scoped>

</style>
